import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import Login from './login';
import Chatbox from './components/messenger/chatbox';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/mchat.css';

export default class MChat extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
		this.state = {
			status: false,
			channel: {
				clubbers: {avatar: '', name: '', message: '', ctime: 0},
				radio: {avatar: '', name: '', message: '', ctime: 0},
				hyper: {avatar: '', name: '', message: '', ctime: 0},
				evolution: {avatar: '', name: '', message: '', ctime: 0},
				technical: {avatar: '', name: '', message: '', ctime: 0}
			},
			current: ''
		};
	}
	
	UNSAFE_componentWillReceiveProps(nextProps) {
		this.component();
	}

	async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.component();
	}

	componentWillUnmount() {
	}

	async component() {
		var params = new URLSearchParams();
		const x = await postApi('/api/v2/chatgroup', params);
		let channel = '';
		switch(true) {
			case /\/mchat\/clubbers/.test(window.location.pathname):
				channel='clubbers';
			break;
			case /\/mchat\/radio/.test(window.location.pathname):
				channel='radio';
			break;
			case /\/mchat\/hyper/.test(window.location.pathname):
				channel='hyper';
			break;
			case /\/mchat\/evolution/.test(window.location.pathname):
				channel='evolution';
			break;
			case /\/mchat\/technical/.test(window.location.pathname):
				channel='technical';
			break;
			default:
				channel='';
			break;
		}
		this.setState({status: true, channel: x.data, current: channel});
	}

	timeAgo(time) {
		const _time = Math.floor( ((Date.now()/1000) - time) / 60) ;
		var _return = '';
		_return = 'just now';
		if( _time >= 1 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		if( time === 0 ) _return = '';
		return( <div className="float-right">&nbsp;&nbsp;{_return}</div> );
	}

	setColourpalette(e) {}

	theatre() {}

	render() {
		const user = this.context;
		return (
			<>
				{this.state.status&&
					<>
						{user.user&&user.user?.access?.verified ?
							<>
								{this.state.current.length>0?
									<Chatbox
										type={this.state.current}
										colour={'#8c52ff'}
										newColour={this.setColourpalette}
										theatre={this.theatre}
										mchat={true}
									/>
								:
									<div className="mchat">
										<div className="mchat-inner">
											<Row className="py-2">
												<Col className="text-center">
													Select Chat Room
												</Col>
											</Row>

											
											<Link to={'/mchat/hyper'}>
												<Row className="py-2 mchat-top">
													<Col>
														<Row>
															<Col className="mchat-group-avatar text-center">
																<img src={`https://mix365.co.uk${this.state.channel.hyper.avatar}`} alt="Chat Avatar" />
															</Col>
															<Col>
																<span className="mchat-message-top"><FontAwesomeIcon icon="user-group" className="mchat-message" /> Mix365 Hyper {this.timeAgo(this.state.channel.hyper.ctime)}</span><br />
																{this.state.channel.hyper.name.length===0?
																	<span className="mchat-message">No messages yet</span>
																:
																	<span className="mchat-message">{this.state.channel.hyper.name} - {this.state.channel.hyper.message}</span>
																}
															</Col>
														</Row>
													</Col>
												</Row>
											</Link>

											<Link to={'/mchat/evolution'}>
												<Row className="py-2 mchat-top">
													<Col>
														<Row>
															<Col style={{maxWidth:60}} className="mchat-group-avatar text-center">
																<img src={`https://mix365.co.uk${this.state.channel.evolution.avatar}`} alt="Chat Avatar" />
															</Col>
															<Col>
																<span className="mchat-message-top"><FontAwesomeIcon icon="user-group" className="mchat-message" /> Mix365 Evolution {this.timeAgo(this.state.channel.evolution.ctime)}</span><br />
																{this.state.channel.evolution.name.length===0?
																	<span className="mchat-message">No messages yet</span>
																:
																	<span className="mchat-message">{this.state.channel.evolution.name} - {this.state.channel.evolution.message}</span>
																}
															</Col>
														</Row>
													</Col>
												</Row>
											</Link>

											{user.user&&user.user?.admin?.mod_access&&
												<Link to={'/mchat/technical'}>
													<Row className="py-2 mchat-top">
														<Col>
															<Row>
																<Col style={{maxWidth:60}} className="mchat-group-avatar text-center">
																	<img src={`https://mix365.co.uk${this.state.channel.technical.avatar}`} alt="Chat Avatar" />
																</Col>
																<Col>
																<span className="mchat-message-top"><FontAwesomeIcon icon="user-group" className="mchat-message" /> Mix365 Technical {this.timeAgo(this.state.channel.technical.ctime)}</span><br />
																	{this.state.channel.technical.name.length===0?
																		<span className="mchat-message">No messages yet</span>
																	:
																		<span className="mchat-message">{this.state.channel.technical.name} - {this.state.channel.technical.message}</span>
																	}
																</Col>
															</Row>
														</Col>
													</Row>
												</Link>
											}
										</div>
									</div>
								}
							</>
							
						:
							<div className="mchat">
								<div className="mchat-inner">
									<Login return="mchat" />
								</div>
							</div>
						}
					</>
				}
			</>
		)
	}
}


